export enum LoginViews {
  mainMenu = "MainMenu",
  login = "Login",
  signup = "Signup",
}
